module.exports = __webpack_public_path__ + "img/Biothon.e11fb6ea.png";